import { render } from "./readBookInfo.vue?vue&type=template&id=ea163f62"
import script from "./readBookInfo.vue?vue&type=script&lang=js"
export * from "./readBookInfo.vue?vue&type=script&lang=js"

import "./readBookInfo.vue?vue&type=style&index=0&id=ea163f62&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__